// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__SnOxl","content":"Consent_content__2AQyW","footer":"Consent_footer__2GLXA"};